import { useQuery } from '@apollo/client';

import {
  GetRdProjectCountForDetailsUpdateQuery,
  GetRdProjectCountForDetailsUpdateQueryVariables,
  GET_RD_PROJECT_COUNT_FOR_DETAILS_UPDATE,
  RdProjectDetailsUpdateScope,
} from '@neo.tax/shared';

export const useRdProjectCountForDetailsUpdate = ({
  fiscalYearId,
  scope,
  skip,
}: {
  fiscalYearId: string;
  scope: RdProjectDetailsUpdateScope;
  skip?: boolean;
}): { count?: number; loading: boolean } => {
  const { data, loading, previousData } = useQuery<
    GetRdProjectCountForDetailsUpdateQuery,
    GetRdProjectCountForDetailsUpdateQueryVariables
  >(GET_RD_PROJECT_COUNT_FOR_DETAILS_UPDATE, {
    variables: { fiscalYearId, scope },
    skip,
    // The count changes as projects are generated, so a cached value from an earlier visit would mislead.
    fetchPolicy: 'network-only',
  });

  // While skipped (the modal is closing), keep showing the last count instead of a blank placeholder.
  const result = skip ? previousData : data;
  return { count: result?.getRdProjectCountForDetailsUpdate, loading };
};
